import { Colors, Helpers, Metrics } from '@origin-digital/style-guide';
import React from 'react';
import styled from 'styled-components';

const ImageHeaderStyles = styled.div`
  position: relative;
  background-color: ${Colors.GREY4};

  &:before {
    content: '';
    display: block;
    margin-top: -${Metrics.Spacing.M_Y}px;
    padding-bottom: 56.25%; /* Stop image flicker */
  }

  .recommended {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    display: inline-block;
    height: 32px;
    background-color: ${Colors.GREEN};
    font-size: ${Metrics.FontSizes.BODY}px;
    line-height: 32px;
    font-weight: ${Metrics.FontWeights.MEDIUM};
    padding: 0 ${Metrics.Spacing.P_X_XS}px;
    color: ${Colors.WHITE};
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  ${Helpers.media.LG`
    &:before {
      margin-top: -${Metrics.Spacing.P_Y_XXL}px;
    }
  `};
`;

export type ImageHeaderImage = 'mini' | 'small' | 'medium' | 'large';

export interface ImageHeaderProps {
  recommended?: boolean;
  image: ImageHeaderImage;
}

export const ImageHeader: React.SFC<ImageHeaderProps> = ({ recommended, image }) => (
  <ImageHeaderStyles>
    <img src={`https://res.cloudinary.com/originenergy/image/upload/v1548113583/solar/solar_system_${image}.jpg`} />
    {recommended ? (
      <div data-id="weRecommend" className="recommended">
        We recommend
      </div>
    ) : null}
  </ImageHeaderStyles>
);
